export function normalizeCookieName(name: string) {
  if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
    return `[development-only]${name}`
  }
  if (process.env.NEXT_PUBLIC_APP_ENV === 'test') {
    return `[test-only]${name}`
  }
  return `$${name}`
}
